<!--#region System Notification-->
@if (sysNotifsList?.length > 0) {
    @if (isMobile()) { <br /><br /> }
    @for (row of sysNotifsList; track row;) {
        <div 
            class="alert text-center system-notif" 
            [ngClass]="row.notificationClassCss"
        >
            <button 
                type="button" 
                class="close" 
                aria-label="Close" 
                (click)="dismiss(row)"
            >
                <span aria-hidden="true">&times;</span>
            </button>
            <h5>{{ row?.title }}</h5>
            <div [innerHtml]="$safeNavigationMigration(row?.message)"></div>
            @if (showWindow) { <div>The window will be from {{ row.startDateStr }} to {{ row.endDateStr }}</div> }
        </div>
    }
}
<!--#endregion-->

<div class="dashboard d-flex flex-column">
    <pcg-bounce-alert />

    <div class="w-100 d-flex justify-content-end mb-1 shadow-sm">
        <pcg-quick-user-info class="py-1 px-2"/>
    </div>
    
    <pcg-push-notification class='w-100'></pcg-push-notification>

    @if (infoService.showSysInvShortcuts()) {
        <div class="w-100">
            <pcg-sys-inv-shortcuts />
        </div>
    }

    @if (showCustomDashboard) {
        <pcg-custom-widget-dashboard></pcg-custom-widget-dashboard>
    }

    <div class="d-flex justify-content-center flex-wrap w-100 overflow-hidden mt-2">
        <span #widgetsContainer></span>
    </div>
</div>